<div
  class="container"
  (click)="toggleCouponsList()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  <div class="flex justify-between mb-4">
    <div>
      Kupon promocyjny
      <app-icon *ngIf="paymentData.paymentStatus === PaymentStatus.CREATED" name="keyboard_arrow_down" size="12">
      </app-icon>
    </div>
    <div *ngIf="selectedCoupon; else noCoupon">
      <div class="amount">- {{ selectedCoupon.amount | number: '1.2-2':'pl' }}&nbsp;zł</div>
    </div>

    <ng-template #noCoupon>
      <div>Brak</div>
    </ng-template>
  </div>
  <div
    class="secondary-text"
    matTooltip="Kwota zostanie zwrócona w ciągu kilku dni po wykonaniu płatności.
        W przypadku odroczenia płatności, należność wobec Twisto zostanie pomniejszona o wysokość kuponu."
  >
    Zwrot po płatności
    <app-icon name="info_outlined" size="12"></app-icon>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="visible"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'transparent'"
  (backdropClick)="closeMenu()"
>
  <div class="overlay-container">
    <div *ngIf="appConfig.config.codeRedemptionActive"
      matRipple class="clear-button add" (click)="addPromoCode()">
      <app-icon name="add" class="mr-10 ml-14" color="#FF6200"></app-icon>
      <div>Dodaj kod promocyjny</div>
    </div>

    <ng-container *ngIf="coupons$ | async as coupons">
      <ng-container *ngIf="coupons.length > 0">
        <div class="title">Twoje kupony</div>
        <app-coupon-select-row [selected]="!selectedCoupon"
                               [disabled]="clickDisabled"
                               (couponClicked)="removeCoupon()"></app-coupon-select-row>

        <ng-container *ngFor="let coupon of coupons">
          <app-coupon-select-row [coupon]="coupon"
                                 [selected]="coupon.couponId === selectedCoupon?.couponId"
                                 [disabled]="clickDisabled"
                                 (couponClicked)="changeCoupon(coupon.couponId)"></app-coupon-select-row>
        </ng-container>
      </ng-container>
    </ng-container>

    <app-coupon-select-row *ngIf="loading && selectedCoupon"
                           [coupon]="selectedCoupon"
                           [selected]="true"
                           [disabled]="true"></app-coupon-select-row>

    <div *ngIf="loading" class="flex flex-col items-center justify-center loader-row">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  </div>
</ng-template>
